interface TestIdReturn {
    'data-testid': string
}

function testId(id: string): TestIdReturn {
    return {
        'data-testid': id
    };
}

export default testId;
